module.exports = __webpack_public_path__ + "img/DSC_0076.c8a47f08.jpg";